import { useState } from 'react';
import { getPortfolioExport } from '../api';
import { exportLoansWorkbook, exportPortfolioWorkbook } from '../reports/portfolioWorkbook';

export function ReportsPage() {
  const [error, setError] = useState<string | null>(null);
  // Which export is running, so the button can say so. The whole portfolio is a few thousand
  // loans plus their packages and notes: one slow request, then a second or two of building.
  const [exporting, setExporting] = useState<'loans' | 'portfolio' | null>(null);

  const runExport = async (which: 'loans' | 'portfolio') => {
    setExporting(which);
    setError(null);
    try {
      const data = await getPortfolioExport();
      if (which === 'loans') exportLoansWorkbook(data);
      else exportPortfolioWorkbook(data);
    } catch (e) {
      setError(String(e));
    } finally {
      setExporting(null);
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <h1>Reports</h1>
      </div>

      {error && <div className="error-banner">{error}</div>}

      <section className="card">
        <h2>Excel exports</h2>
        <div className="export-actions">
          <button className="btn-primary" disabled={exporting !== null} onClick={() => void runExport('loans')}>
            {exporting === 'loans' ? 'Building…' : 'Loans'}
          </button>
          <button className="btn-primary" disabled={exporting !== null} onClick={() => void runExport('portfolio')}>
            {exporting === 'portfolio' ? 'Building…' : 'Loans, packages & notes'}
          </button>
        </div>
      </section>
    </div>
  );
}
